var React = require('react');

function X (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13 0C5.8203 0 0 5.59644 0 12.5C0 19.4036 5.8203 25 13 25C20.1797 25 26 19.4036 26 12.5C26 5.59644 20.1797 0 13 0ZM19.0945 5.95801L14.0396 11.8296H14.0393L19.5371 19.8247H15.4938L11.7915 14.4408L7.15642 19.8247H5.9585L11.2597 13.6674L5.9585 5.95801H10.0018L13.5075 11.0562L17.8967 5.95801H19.0945ZM11.8618 12.9677L12.3989 13.7353V13.7356L16.0573 18.9645H17.8973L13.4141 12.5566L12.8769 11.7889L9.428 6.85912H7.58805L11.8618 12.9677Z","fill":"white"}));
}

X.defaultProps = {"width":"26","height":"25","viewBox":"0 0 26 25","fill":"none"};

module.exports = X;

X.default = X;
